import { Grid, Typography, useTheme } from "@mui/material";
import { Clock } from "react-feather";

export const ComingSoon = () => {
  const theme = useTheme();

  return (
    <Grid
      container
      display="flex"
      my={30}
      alignItems="center"
      maxWidth="30%"
      mx="auto"
    >
      <Typography color="primary.main" fontSize={30} textAlign="center" mr={2}>
        Coming Soon
      </Typography>
      <Clock color={theme.palette.primary.main} size={35} />
    </Grid>
  );
};
